import { render } from "./importaciones.vue?vue&type=template&id=55c31834&scoped=true"
import script from "./importaciones.vue?vue&type=script&lang=js"
export * from "./importaciones.vue?vue&type=script&lang=js"

import "./importaciones.vue?vue&type=style&index=0&id=55c31834&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c31834"]])

export default __exports__